import axios from 'axios'
import qs from 'qs'
import merge from 'lodash/merge'
import { getToken, toLogin } from '@/utils/auth'
import { Notify  } from 'vant';
// import { Toast } from 'vant';

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 30000
})
// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  const isToken = (config.headers || {}).isToken === false
  let token = getToken()
  if (token && !isToken) {
    config.headers['wxpub-tk'] = token // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  // if(config.headers['Content-Type'] === 'application/x-www-form-urlencoded'){
  //   config.data = qs.stringify(config.data)
  // }
  return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = res.data.msg || '服务器出了点小差'
    if (code === 401) {
      // TOKEN超时
      //location.href = '/index';
      toLogin()
    } else if (code === 500) {
      Notify({ type: 'danger', message: msg });
      // Toast.fail(msg);
      return Promise.reject(new Error(msg))
    } else if (code !== 200) {
      Notify({ type: 'danger', message: msg });
      // Toast.fail(msg);
      return Promise.reject('error')
    } else {
      return res.data
    }
  },
  error => {
    console.log('err' + error)
    let { message } = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    }
    else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    }
    else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Notify({ type: 'danger', message: message });
    // Toast.fail(message);
    return Promise.reject(error)
  }
)


/**
 * get请求参数处理
 * @param {*} params 参数对象
 * @param {*} openDefultParams 是否开启默认参数?
 */
service.adornParams = (params = {}, openDefultParams = true) => {
  var defaults = {
    't': new Date().getTime()
  }
  return openDefultParams ? merge(defaults, params) : params
}

/**
 * post请求数据处理
 * @param {*} data 数据对象
 * @param {*} openDefultdata 是否开启默认数据?
 * @param {*} contentType 数据格式
 *  json: 'application/json; charset=utf-8'
 *  form: 'application/x-www-form-urlencoded; charset=utf-8'
 */
service.adornData = (data = {}, openDefultdata = true, contentType = 'json') => {
  var defaults = {
    't': new Date().getTime()
  }
  data = openDefultdata ? merge(defaults, data) : data
  return contentType === 'json' ? JSON.stringify(data) : qs.stringify(data)
}

service.postForm = (config, openDefultdata = true) => {
  config.data = service.adornData(config.data, openDefultdata, 'form');
  config.method =  'post'
  let headers = config.headers;
  if(!headers){
    headers = {};
    config.headers = headers;
  }
  headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=utf-8'
  return service(config);
}

export default service
